jQuery(document).ready(function ($) {
    $('.products-slider-swiper').each(function (index, el) {
        const $container = $(el);
        const $parentBlock = $container.closest('.products-slider-block');

        new Swiper(el, {
            loop: false,
            spaceBetween: 24,
            slidesPerView: 1, // Default (mobile)
            pagination: {
                el: $container.find('.swiper-pagination')[0] || null,
                type: 'progressbar',
            },
            navigation: {
                nextEl: $parentBlock.find('.products-slider-button-next')[0] || null,
                prevEl: $parentBlock.find('.products-slider-button-prev')[0] || null,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 16
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 24
                },
                992: {
                    slidesPerView: 4,
                    spaceBetween: 24
                }
            },
            on: {
                init: function () {
                    updateSlideClasses(this, $container);
                },
                slideChange: function () {
                    updateSlideClasses(this, $container);
                }
            }
        });

        function updateSlideClasses(swiper, $container) {
            $container.find('.swiper-slide').removeClass('manual-active-slide');
            $($container.find('.swiper-slide')[swiper.activeIndex]).addClass('manual-active-slide');
        }
    });
});
